import gql from 'graphql-tag';
import automaticMailSendFragment from '../automaticMailSend';
import automaticMailFragment from '../automaticMail';

export default gql`
  fragment automaticMailSendProspectActivityFragment on AutomaticMailSendProspectActivity {
    id
    automaticMailSend {
      ...automaticMailSendFragment
      mailAttachments {
        uuid
        filename
        extension
      }
      automaticMail {
        ...automaticMailFragment
        stepAutomaticMail {
          step {
            name
          }
        }
      }
    }
    hubspotEmailIdString
    hubspotContactIdString
    createdAt
  }
  ${automaticMailSendFragment}
  ${automaticMailFragment}
`;
